import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const passwordResetInputSchema = z.object({
  email: z.string().email().max(254),
})

export const Route = createFileRoute("/api/dashboard/auth/password-reset")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = passwordResetInputSchema.parse(await request.json())
            const { requestDashboardPasswordReset } = await import("@api/auth/dashboardPasswordResetApi")
            await requestDashboardPasswordReset({
              ...input,
              baseUrl: new URL(request.url).origin,
            })
            return Response.json({ sent: true })
          } catch (error) {
            return Response.json(
              {
                error: error instanceof Error ? error.message : "Could not send password reset.",
              },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
